import React, { useState, useEffect } from 'react';
import { Button, Card, Space, Modal, Progress, message, Spin } from 'antd';
import { Form, InputGroup, Table, Badge } from 'react-bootstrap';
import { SearchOutlined, PlusOutlined, EditOutlined, DeleteOutlined, LoadingOutlined, EyeOutlined, LoginOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import { DatePicker } from 'antd';
import { useNavigate } from 'react-router-dom';
import AddDoctors from './Components/AddDoctors';
import AddHospitals from './Components/AddHospitals';
import EditHospitals from './Components/EditHospitals';
import { formatUrlString } from '../services/apiService';
import axios from 'axios';
import { oneKlicks } from '../SDK/oneclick';
import { OneKlicksFileSDK } from '../SDK/OneKlicksFileSDK';
import ImageShow from '../Uitiles/ImageShow';
import { encryptId, getServiceId, getuserdata, loginapi } from '../services/apiService';
import { sendWhatsApp } from '../SDK/oneclick';
import EditDoctors from './Components/EditDoctors';
import decodeHtml from '../Uitiles/decodeHtml';
import SpecialityName from './Components/SpecialityName';
import Preloader from '../Uitiles/Preloader';
import { debugLog } from '../utils/debug';
import Paginationnew from '../Uitiles/Paginationnew';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import AddInvoiceModel from './Pages/Components/AddInvoiceModel';

/**
 * IMPORTANT: Call Remarks Feature
 * 
 * The call_remarks functionality requires a 'call_remarks' TEXT column in the 'users' table.
 * Currently, the OneKlicks API doesn't support dynamic column addition, so this column
 * must be added manually by the database administrator.
 * 
 * When the column is missing:
 * - The UI will show a warning message
 * - Call status updates will still work (without remarks)
 * - Users will be prompted to contact support
 * 
 * To enable full functionality, run this SQL:
 * ALTER TABLE users ADD COLUMN call_remarks TEXT NULL;
 */

// Doctor Model
class HospitalModel {
    constructor(data = {}) {
        this.id = data.id || '';
        this.old_id = data.old_id || '';
        this.name = data.name || '';
        this.slug = data.slug || '';
        this.email = data.email || '';
        this.phone = data.phone || '';
        this.display_name = data.display_name || '';
        this.url = data.url || '';
        this.speciality_id = data.speciality_id || '';
        this.experience = data.experience || '';
        this.qualification = data.qualification || '';
        this.status = data.status;
        this.country = data.country || '';
        this.address = data.address || '';
        this.created_at = data.created_at || new Date().toISOString();
        this.updated_at = data.updated_at || new Date().toISOString();
        this.profile_photo = data.profile_photo || '';
        this.profile_photo_url = data.profile_photo_url || '';
        this.profile_url = data.profile_url || '';
        this.call_status = data.call_status || '';
        this.call_status_date = data.call_status_date || '';
    }

    toJSON() {
        return {
            id: this.id,
            old_id: this.old_id,
            name: this.name,
            slug: this.slug,
            email: this.email,
            phone: this.phone,
            display_name: this.display_name,
            url: this.url,
            speciality_id: this.speciality_id,
            experience: this.experience,
            qualification: this.qualification,
            status: this.status,
            country: this.country,
            address: this.address,
            created_at: this.created_at,
            updated_at: this.updated_at,
            profile_photo: this.profile_photo,
            profile_photo_url: this.profile_photo_url,
            profile_url: this.profile_url,
            call_status: this.call_status,
            call_status_date: this.call_status_date
        };
    }

    static fromAPI(data) {
        return new HospitalModel({
            id: data.id,
            old_id: data.old_id,
            name: data.name,
            slug: data.slug,
            email: data.email,
            phone: data.phone,
            display_name: data.display_name,
            url: data.url,
            speciality_id: data.speciality_id,
            experience: data.experience,
            qualification: data.qualification,
            status: data.status,
            country: data.country,
            address: data.address,
            created_at: data.created_at,
            updated_at: data.updated_at,
            profile_photo: data.profile_photo,
            profile_photo_url: data.profile_photo_url,
            profile_url: data.profile_url,
            call_status: data.call_status,
            call_status_date: data.call_status_date
        });
    }
}

const Hospitals = () => {
    const navigate = useNavigate();
    const { login, isLoggedIn, userData } = useAuth();
    const [searchText, setSearchText] = useState('');
    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showImportModal, setShowImportModal] = useState(false);
    const [modalData, setModalData] = useState(new HospitalModel());
    const [imagePreview, setImagePreview] = useState(null);
    const [isImporting, setIsImporting] = useState(false);
    const [importProgress, setImportProgress] = useState(0);
    const [currentImportItem, setCurrentImportItem] = useState('');
    const [usertype, setUsertype] = useState('');
    const [showEditModal, setShowEditModal] = useState(false);
    const [editData, setEditData] = useState({});
    const [loading, setLoading] = useState(false);
    const [showImportModalimage, setShowImportModalimage] = useState(false);
    const [showImportGoogleId, setShowImportGoogleId] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [speciality, setSpeciality] = useState('');
    const [specialities, setSpecialities] = useState([]);
    const [showPackageModal, setShowPackageModal] = useState(false);
    const [selectedHospital, setSelectedHospital] = useState(null);

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(20);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        getHospitals();
        getSpecialities();
    }, []);

    useEffect(() => {
        getHospitals();
    }, [searchText, page]);

    const getSpecialities = async () => {
        try {
            const tableSchema = '';
            const tableName = 'specialities';
            const conditions = {};
            const orderBy = 'id DESC';
            const search = '';
            const pagination = '';
            const margedata = '';
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            debugLog('getSpecialities response', response);
            if (response.data && response.data.length > 0) {
                setSpecialities(response.data);
            } else {
                setSpecialities([]);
            }
        } catch (error) {
            message.error('Failed to fetch specialities');
        }
    }


    // Package Modal functionality
    const openPackageModal = async (doctor) => {
        console.log("doctor selected for package:", doctor);
        setShowPackageModal(true);
        setSelectedHospital(doctor);
    };

    const closePackageModal = () => {
        setShowPackageModal(false);
        setSelectedHospital(null);
    };

    const getHospitals = async () => {
        try {
            setLoading(true);
            const tableSchema = '';
            const tableName = 'users';
            const conditions = {
                user_type: 'hospitals'
            };
            const orderBy = 'id DESC';
            const search = {
                ...searchText && {
                    name: searchText,
                    email: searchText,
                    phone: searchText,
                    display_name: searchText,
                    address: searchText,
                    status: searchText,
                    speciality_id: searchText,
                    country: searchText
                }
            };

            const pagination = {
                page: page,
                limit: limit
            };
            const margedata = [
                {
                    target_table: "hospitals_default_location",
                    target_column: "user_id",
                    target_value: "id",
                    target_label: "location"
                },
                {
                    target_table: "user_package",
                    target_column: "user_id",
                    target_value: "id",
                    target_label: "user_package",
                    margedata: [
                        {
                            target_table: "packages",
                            target_column: "id",
                            target_value: "package_id",
                            target_label: "package_details"
                        }
                    ]
                },
            ];

            const location = await getuserdata('location');
            const usertype = await getuserdata('user_type');

            console.log("location doctors :", location);

            let range = [];
            if (usertype === 'staff' && location) {
                try {
                    const parsedLocation = typeof location === 'string' ? JSON.parse(location) : location;
                    if (parsedLocation && (parsedLocation.lat || parsedLocation.latitude) && (parsedLocation.lng || parsedLocation.longitude)) {
                        range = {
                            latitude: parsedLocation.lat || parsedLocation.latitude,
                            longitude: parsedLocation.lng || parsedLocation.longitude,
                            radius: 20, // in kilometers
                            target_latitude: "lat",
                            target_longitude: "lng",
                            table_name: "hospitals_default_location",       // join table
                            join_column: "user_id",            // foreign key in user_location
                            base_column: "id"                  // primary key in user
                        };
                    }
                } catch (e) {
                    console.error("Error processing location data:", e);
                }
            }

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata, range);

            if (!response || !response.data) {
                throw new Error('Invalid response from server');
            }

            debugLog('getHospitals response', response.data);
            const hospitals = response.data.map(item => HospitalModel.fromAPI(item));
            setData(hospitals);
            setTotalPages(response.totalPages);
            setUsertype(usertype);
        } catch (error) {
            console.error('getHospitals response:', error);
            message.error('Failed to fetch hospitals. Please try again.');
            setData([]);
        } finally {
            setLoading(false);
        }
    }

    const openModal = () => {
        setShowModal(true);
        setModalData(new HospitalModel());
        setImagePreview(null);
    };

    const closeModal = () => setShowModal(false);

    const openImportModal = () => {
        setShowImportModal(true);
    };

    const openImportModalimage = () => {
        setShowImportModalimage(true);
    };

    const openImportGoogleId = () => {
        setShowImportGoogleId(true);
    };

    const closeImportModal = () => {
        setShowImportModal(false);
    };

    const closeImportModalimage = () => {
        setShowImportModalimage(false);
    };

    const closeImportGoogleId = () => {
        setShowImportGoogleId(false);
    };

    const handleImportGoogleId = async () => {
        setIsImporting(true);
        setImportProgress(0);
        let successCount = 0;
        let errorCount = 0;

        try {
            const hospitalIds = data;
            const totalItems = data.length;
            let processedItems = 0;

            for (const hospitalId of hospitalIds) {
                try {
                    setCurrentImportItem(`Processing hospital ID: ${hospitalId.display_name}`);

                    // Get individual doctor data
                    const doctorResponse = await axios.post('//css.meddylist.com//wp-json/api/v1/listing/get_doctor', {
                        "user_id": hospitalId.id
                    });

                    console.log("doctorResponse", doctorResponse.data[0]);

                    if (!doctorResponse.data || !doctorResponse.data[0]) {
                        throw new Error('Invalid hospital data received');
                    }

                    const doctor = doctorResponse.data[0];

                    // Create doctor in database
                    const tableSchema = '';
                    const tableName = 'users';
                    const doctorModel = {   //address
                        speciality_ids: JSON.stringify(doctor.specialities),
                        address: doctor.address,
                        longitude: doctor.longitude,
                        latitude: doctor.latitude

                    };

                    const conditions = {
                        id: hospitalId.id
                    };


                    const createResponse = await oneKlicks.update(tableSchema, tableName, doctorModel, conditions);

                    if (createResponse && createResponse.success) {
                        successCount++;
                        message.success(`Successfully imported: ${hospitalId.display_name}`);
                    } else {
                        errorCount++;
                        message.error(`Failed to import: ${hospitalId.display_name}`);
                    }

                    processedItems++;
                    const progress = Math.round((processedItems / totalItems) * 100);
                    setImportProgress(progress);

                    // Add a small delay to prevent overwhelming the server
                    await new Promise(resolve => setTimeout(resolve, 500));

                } catch (error) {
                    console.error('Import failed:', error);
                    message.error('Import failed. Please try again.');
                }
            }

            message.success(`Import completed! Successfully imported ${successCount} items. ${errorCount} items failed.`);
            await getHospitals(); // Refresh the list after import

        } catch (error) {
            console.error('Import failed:', error);
            message.error('Import failed. Please try again.');
        } finally {
            setIsImporting(false);
            setCurrentImportItem('');
            setImportProgress(0);
            closeImportGoogleId();
        }
    };

    const handleImport = async () => {
        setIsImporting(true);
        setImportProgress(0);
        let successCount = 0;
        let errorCount = 0;

        try {
            const hospitalIds = data;
            const totalItems = data.length;
            let processedItems = 0;

            for (const hospitalId of hospitalIds) {
                try {
                    setCurrentImportItem(`Processing hospital ID: ${hospitalId.display_name}`);

                    // Get individual doctor data
                    const doctorResponse = await axios.post('//css.meddylist.com//wp-json/api/v1/listing/get_doctor', {
                        "user_id": hospitalId.id
                    });

                    console.log("doctorResponse", doctorResponse.data[0]);



                    const specialities = doctorResponse.data[0].specialities;

                    console.log("specialities", specialities);

                    for (const speciality in specialities) {
                        console.log("speciality", speciality);
                        for (const serviceId in specialities[speciality]) {
                            console.log("serviceId", serviceId);
                            const serviceData = specialities[speciality][serviceId];
                            for (const service of serviceData) {
                                console.log("service", service);
                                console.log("price", service.price);
                                console.log("description", service.description);
                            }
                            const getServiceId = await getServiceId(serviceId);
                        }
                    }

                    if (!doctorResponse.data || !doctorResponse.data[0]) {
                        throw new Error('Invalid hospital data received');
                    }

                    const doctor = doctorResponse.data[0];

                    // // Upload profile photo if exists
                    let profile_photo = '';
                    if (doctor.image) {
                        const root = 'doctors';
                        const status = 'publish';
                        const uploadimage = await OneKlicksFileSDK.uploadFileFromUrl(root, status, doctor.image);
                        if (uploadimage && uploadimage.fileId) {
                            profile_photo = uploadimage.fileId;
                        }
                    }



                    // Create doctor in database
                    const tableSchema = '';
                    const tableName = 'users';
                    const doctorModel = {
                        address: doctor.address || '',
                        longitude: doctor.longitude || '',
                        latitude: doctor.latitude || '',
                        email: doctor.email || '',
                        first_name: doctor.first_name || '',
                        last_name: doctor.last_name || '',
                        subheading: doctor.sub_heading || '',
                        description: doctor.short_description || '',
                        starting_price: doctor.starting_price || '',
                        contents: doctor.contents || '',
                        phone: doctor.phone || '',
                        profile_photo: profile_photo,
                        experience: doctor.experience || '',
                        qualification: doctor.qualification || '',
                        country: doctor.country || '',
                        speciality_ids: specialities
                    };

                    const conditions = {
                        id: hospitalId.id
                    };

                    const createResponse = await oneKlicks.update(tableSchema, tableName, doctorModel, conditions);

                    if (createResponse && createResponse.success) {
                        successCount++;
                        message.success(`Successfully imported: ${hospitalId.display_name}`);
                    } else {
                        errorCount++;
                        message.error(`Failed to import: ${hospitalId.display_name}`);
                    }

                    processedItems++;
                    const progress = Math.round((processedItems / totalItems) * 100);
                    setImportProgress(progress);

                    // Add a small delay to prevent overwhelming the server
                    await new Promise(resolve => setTimeout(resolve, 500));

                } catch (error) {
                    errorCount++;
                    console.error(`Error processing hospital ID ${hospitalId}:`, error);
                    message.error(`Failed to import hospital ID ${hospitalId}: ${error.message}`);
                }
            }

            message.success(`Import completed! Successfully imported ${successCount} items. ${errorCount} items failed.`);
            await getHospitals(); // Refresh the list after import

        } catch (error) {
            console.error('Import failed:', error);
            message.error('Import failed. Please try again.');
        } finally {
            setIsImporting(false);
            setCurrentImportItem('');
            setImportProgress(0);
            closeImportModal();
        }
    };

    const handleImportImages = async () => {
        setIsImporting(true);
        setImportProgress(0);
        let successCount = 0;
        let errorCount = 0;

        try {
            const hospitalIds = data;
            const totalItems = data.length;
            let processedItems = 0;

            for (const hospitalId of hospitalIds) {
                try {
                    setCurrentImportItem(`Processing hospital ID: ${hospitalId.display_name}`);

                    if (hospitalId.profile_url == null) {
                        const imageResponse = await OneKlicksFileSDK.getfile(hospitalId.profile_photo);

                        console.log("imageResponse", imageResponse.fileUrl);

                        if (imageResponse && imageResponse.fileUrl) {
                            // Remove https://apis.oneklicks.com from the URL
                            const cleanUrl = imageResponse.fileUrl.replace('https://apis.oneklicks.com', '');
                            const fullUrl = imageResponse.fileUrl;

                            const tableSchema = '';
                            const tableName = 'users';
                            const updateData = {
                                profile_url: cleanUrl,
                                profile_photo_url: fullUrl
                            };
                            const condition = {
                                id: hospitalId.id
                            };
                            const updateResponse = await oneKlicks.update(tableSchema, tableName, updateData, condition);
                            if (updateResponse && updateResponse.success) {
                                successCount++;
                                message.success(`Successfully imported: ${hospitalId.display_name}`);
                            } else {
                                errorCount++;
                                message.error(`Failed to update database for: ${hospitalId.display_name}`);
                            }
                        } else {
                            errorCount++;
                            message.error(`No image found for: ${hospitalId.display_name} (ID: ${hospitalId.profile_photo || 'Missing'})`);
                        }

                        processedItems++;
                        const progress = Math.round((processedItems / totalItems) * 100);
                        setImportProgress(progress);

                        // Add a small delay to prevent overwhelming the server
                        await new Promise(resolve => setTimeout(resolve, 500));
                    }
                } catch (error) {
                    errorCount++;
                    console.error(`Error processing hospital ID ${hospitalId.id}:`, error);
                    message.error(`Failed to import hospital ID ${hospitalId.id}: ${error.message}`);
                }
            }

            message.success(`Import completed! Successfully imported ${successCount} items. ${errorCount} items failed.`);
            await getHospitals(); // Refresh the list after import

        } catch (error) {
            console.error('Import failed:', error);
            message.error('Import failed. Please try again.');
        } finally {
            setIsImporting(false);
            setCurrentImportItem('');
            setImportProgress(0);
            closeImportModalimage();
        }
    };

    const handleSubmit = () => {
        setData([...data, modalData]);
        closeModal();
    };

    const handleNavigation = (userData) => {
        setTimeout(() => {
            switch (userData.user_type?.toLowerCase()) {
                case "admin":
                    navigate("/admin-dashboard");
                    break;
                case "doctor":
                    navigate(`/doctor/dashboard/${encryptId(userData.id)}`);
                    break;
                case "hospitals":
                    navigate("/hospital/dashboard");
                    break;
                case "regular_users":
                    navigate("/patient/dashboard");
                    break;
                case "patient":
                    navigate("/patient-dashboard");
                    break;
                case "pharmacy":
                    navigate("/pharmacy/dashboard");
                    break;
                case "user":
                    // Stay on home page - user can access dashboard from header dropdown
                    navigate("/");
                    break;
                case "administrator":
                    navigate("/superadmin/dashboard");
                    break;
                case "staff":
                    navigate("/superadmin/dashboard");
                    break;
                case "editor":
                    navigate("/editor/dashboard");
                    break;
                default:
                    // For unknown roles, stay on home page
                    navigate("/");
                    break;
            }
        }, 1500);
    };

    const createEmail = async (display_name) => {
        const randomNumber = Math.floor(1000 + Math.random() * 9000); // 4 digits
        const email = `${display_name}${Date.now()}${randomNumber}@meddylist.com`;
        return email;
    };

    const handleEdit = async (record, event) => {
        // Prevent default anchor behavior
        const persintuser = await getuserdata('full');
        console.log("persintuser", persintuser);

        // save the persintuser to the record in local storage
        localStorage.setItem('presentuser', JSON.stringify(persintuser));
        localStorage.setItem('redirect_url_admin', '/superadmin/hospitals');

        const localuser = localStorage.getItem("presentuser");
        console.log("localuser", localuser);

        console.log('Attempting email login...');
        if (record.email == "") {
            const createemail = await createEmail(record.display_name);
            record.email = createemail;
            const tableSchema = '';
            const tableName = 'users';
            const data = {
                email: createemail
            };
            const condition = {
                id: record.id
            };
            const updateemail = await oneKlicks.update(tableSchema, tableName, data, condition);
            if (updateemail && updateemail.success) {
                console.log('Email created successfully');
            } else {
                console.log('Failed to create email');
            }
        }
        const loginResponse = await loginapi(record.email, record.pass, true);
        console.log('Login response:', loginResponse);

        const user = loginResponse.data[0];

        if (user) {
            if (user.status === "2") {
                toast.error("Your account has been deleted. Please contact support.");
                return;
            }

            const userData = {
                id: user.id,
                email: user.email,
                user_type: user.user_type,
                display_name: user.display_name || user.email
            };

            console.log('User data prepared for login:', userData);
            // Use the login function from AuthContext
            const loginSuccess = await login(userData);
            console.log('Login success status:', loginSuccess);

            if (loginSuccess) {
                toast.success("Login successful!", { autoClose: 2000 });
                handleNavigation(userData);
            } else {
                console.error('Login failed - login function returned false');
                toast.error("Login failed. Please try again.");
            }
        } else {
            console.error('No user data in response');
            toast.error("Invalid credentials. Please try again.");
        }
    };

    const handleEditProfile = (record) => {
            setEditData(record);
            setShowEditModal(true);
        };

        const handleDelete = (record, event) => {
            // Prevent default anchor behavior
            if (event) {
                event.preventDefault();
            }
            console.log("handleDelete record", record);
            const confirmDelete = window.confirm(`Are you sure you want to delete "${decodeHtml(record.name)}"?`);

            if (confirmDelete) {
                try {
                    const tableSchema = '';
                    const tableName = 'users';
                    oneKlicks.delete(tableSchema, tableName, { id: record.id })
                        .then(response => {
                            if (response && response.success) {
                                message.success('Doctor deleted successfully');
                                OneKlicksFileSDK.deleteFile(record.url).then(response => {
                                    console.log(response);
                                    getHospitals();
                                })
                            } else {
                                message.error('Failed to delete doctor');
                            }
                        })
                        .catch(error => {
                            console.error('Error deleting doctor:', error);
                            message.error('Failed to delete doctor');
                        });

                } catch (error) {
                    console.error('Error deleting doctor:', error);
                    message.error('Failed to delete doctor');
                }
            }
        };

        const handleStatusToggle = async (record) => {
            try {
                const newStatus = record.status == 1 ? 0 : 1;
                const statusText = newStatus == 1 ? 'Active' : 'Inactive';

                const tableSchema = '';
                const tableName = 'users';
                const payload = { status: newStatus };
                const condition = { id: record.id };

                const response = await oneKlicks.update(tableSchema, tableName, payload, condition);

                if (response && response.success) {
                    message.success(`Status changed to ${statusText}`);
                    await getHospitals(); // Refresh the list
                } else {
                    message.error('Failed to update status');
                }
            } catch (error) {
                console.error('Error updating status:', error);
                message.error('Failed to update status');
            }
        };

        const handlePageChange = (page) => {
            setPage(page);
        };

        const handleFileChange = (event) => {
            const files = Array.from(event.target.files);
            setSelectedFiles(files);
        };

        const [callStatusOptions] = useState([
            { value: 'Reschedule', label: 'Reschedule' },
            { value: 'Not Respond', label: 'Not Respond' },
            { value: 'Wrong Number', label: 'Wrong Number' },
            { value: 'Not Interested', label: 'Not Interested' },
            { value: 'Not Answered', label: 'Not Answered' },
        ]);
        const [callStatusValue, setCallStatusValue] = useState(null);
        const [rescheduleDate, setRescheduleDate] = useState('');
        const [callStatusModelshow, setCallStatusModelshow] = useState(false);
        const [selectedDoctorForCallStatus, setSelectedDoctorForCallStatus] = useState(null);
        const [callStatusDate, setCallStatusDate] = useState('');
        const [callRemarks, setCallRemarks] = useState('');

        const openCallStatusModal = async (doctor) => {
            try {
                // Fetch fresh data for this specific doctor to get latest call status
                const tableSchema = '';
                const tableName = 'users';
                const conditions = { id: doctor.id };
                const orderBy = '';
                const search = {};
                const pagination = { page: 1, limit: 1 };
                const margedata = [];

                const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

                if (response && response.data && response.data.length > 0) {
                    const freshDoctorData = response.data[0];
                    setSelectedDoctorForCallStatus(freshDoctorData);

                    // Initialize selection from fresh data
                    if (freshDoctorData && typeof freshDoctorData.call_status === 'string') {
                        if (freshDoctorData.call_status.startsWith('Reschedule')) {
                            setCallStatusValue('Reschedule');
                        } else if (freshDoctorData.call_status === 'Not Respond') {
                            setCallStatusValue('Not Respond');
                        } else if (freshDoctorData.call_status === 'Wrong Number') {
                            setCallStatusValue('Wrong Number');
                        } else if (freshDoctorData.call_status === 'Not Interested') {
                            setCallStatusValue('Not Interested');
                        } else if (freshDoctorData.call_status === 'Not Answered') {
                            setCallStatusValue('Not Answered');
                        } else {
                            setCallStatusValue(null);
                        }
                    } else {
                        setCallStatusValue(null);
                    }

                    setRescheduleDate(freshDoctorData.call_status_date);
                    setCallStatusDate(freshDoctorData.call_status_date);
                    setCallRemarks(freshDoctorData.call_remarks || '');
                } else {
                    // Fallback to original data if fetch fails
                    setSelectedDoctorForCallStatus(doctor);
                    if (doctor && typeof doctor.call_status === 'string') {
                        if (doctor.call_status.startsWith('Reschedule')) {
                            setCallStatusValue('Reschedule');
                        } else if (doctor.call_status === 'Not Respond') {
                            setCallStatusValue('Not Respond');
                        } else if (doctor.call_status === 'Wrong Number') {
                            setCallStatusValue('Wrong Number');
                        } else if (doctor.call_status === 'Not Interested') {
                            setCallStatusValue('Not Interested');
                        } else if (doctor.call_status === 'Not Answered') {
                            setCallStatusValue('Not Answered');
                        } else {
                            setCallStatusValue(null);
                        }
                    } else {
                        setCallStatusValue(null);
                    }
                    setRescheduleDate(doctor.call_status_date);
                    setCallStatusDate(doctor.call_status_date);
                    setCallRemarks(doctor.call_remarks || '');
                }
            } catch (error) {
                console.error('Error fetching fresh doctor data:', error);
                // Fallback to original data if fetch fails
                setSelectedDoctorForCallStatus(doctor);
                if (doctor && typeof doctor.call_status === 'string') {
                    if (doctor.call_status.startsWith('Reschedule')) {
                        setCallStatusValue('Reschedule');
                    } else if (doctor.call_status === 'Not Respond') {
                        setCallStatusValue('Not Respond');
                    } else if (doctor.call_status === 'Wrong Number') {
                        setCallStatusValue('Wrong Number');
                    } else if (doctor.call_status === 'Not Interested') {
                        setCallStatusValue('Not Interested');
                    } else if (doctor.call_status === 'Not Answered') {
                        setCallStatusValue('Not Answered');
                    } else {
                        setCallStatusValue(null);
                    }
                } else {
                    setCallStatusValue(null);
                }
                setRescheduleDate(doctor.call_status_date);
                setCallStatusDate(doctor.call_status_date);
                setCallRemarks(doctor.call_remarks || '');
            }

            setCallStatusModelshow(true);
        };

        const renderCallHistory = () => {
            try {
                const callHistory = selectedDoctorForCallStatus?.call_status_date ?
                    (typeof selectedDoctorForCallStatus.call_status_date === 'string' ?
                        JSON.parse(selectedDoctorForCallStatus.call_status_date) :
                        selectedDoctorForCallStatus.call_status_date) : null;

                if (callHistory && callHistory.date) {
                    return (
                        <div>
                            <p><strong>Current Status:</strong> {selectedDoctorForCallStatus.call_status || 'Not Set'}</p>
                            {selectedDoctorForCallStatus.call_remarks && (
                                <div style={{
                                    padding: '10px',
                                    margin: '10px 0',
                                    backgroundColor: '#fff3cd',
                                    border: '1px solid #ffeaa7',
                                    borderRadius: '4px'
                                }}>
                                    <p style={{ margin: '0', fontWeight: 'bold', color: '#856404' }}>📝 Current Remarks:</p>
                                    <p style={{ margin: '5px 0 0 0', color: '#856404' }}>{selectedDoctorForCallStatus.call_remarks}</p>
                                </div>
                            )}

                            {/* Show note if remarks field is not available in database */}
                            {!selectedDoctorForCallStatus.call_remarks && callRemarks && callRemarks.trim() !== '' && (
                                <div style={{
                                    padding: '10px',
                                    margin: '10px 0',
                                    backgroundColor: '#f8d7da',
                                    border: '1px solid #f5c6cb',
                                    borderRadius: '4px'
                                }}>
                                    <p style={{ margin: '0', fontWeight: 'bold', color: '#721c24' }}>⚠️ Remarks Not Saved:</p>
                                    <p style={{ margin: '5px 0 0 0', color: '#721c24' }}>"{callRemarks}"</p>
                                    <p style={{ margin: '5px 0 0 0', fontSize: '12px', color: '#721c24' }}>
                                        <em>Database field 'call_remarks' not available. Contact administrator to add this field.</em>
                                    </p>
                                </div>
                            )}
                            {callHistory.date.time && Array.isArray(callHistory.date.time) && callHistory.date.time.length > 0 ? (
                                <div>
                                    <p><strong>Reschedule History:</strong></p>
                                    <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                        {callHistory.date.time.map((entry, index) => (
                                            <div key={index} style={{
                                                padding: '8px',
                                                margin: '5px 0',
                                                backgroundColor: 'white',
                                                border: '1px solid #e8e8e8',
                                                borderRadius: '4px'
                                            }}>
                                                <span style={{ fontWeight: 'bold' }}>📅 {new Date(entry.date).toLocaleString()}</span>
                                                <br />
                                                <span style={{ fontSize: '12px', color: '#666' }}>User ID: {entry.user_id}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <p style={{ color: '#666', fontStyle: 'italic' }}>No reschedule history available</p>
                            )}
                        </div>
                    );
                } else {
                    return <p style={{ color: '#666', fontStyle: 'italic' }}>No call history available</p>;
                }
            } catch (error) {
                return <p style={{ color: '#666', fontStyle: 'italic' }}>No call history available</p>;
            }
        };

        // Share Profile functionality
        const [showShareModal, setShowShareModal] = useState(false);
        const [selectedDoctorForShare, setSelectedDoctorForShare] = useState(null);
        const shareTypeOptions = [
            { value: 'details', label: 'Profile Details' },
            { value: 'link', label: 'Profile Link' },
            { value: 'whatsapp', label: 'WhatsApp' }
        ];
        const [shareType, setShareType] = useState('link');
        const [shareSending, setShareSending] = useState(false);

        const handleShareProfile = (doctor) => {
            setSelectedDoctorForShare(doctor);
            setShowShareModal(true);
        };

        const closeShareModal = () => {
            setShowShareModal(false);
            setSelectedDoctorForShare(null);
        };

        const copyToClipboard = (text) => {
            navigator.clipboard.writeText(text).then(() => {
                message.success('Copied to clipboard!');
            }).catch(() => {
                message.error('Failed to copy to clipboard');
            });
        };
        const encryptId = (id) => {
            const salt = 'meddylist';
            const encrypted = btoa(id + salt);
            return encrypted;
        };



        const generateProfileLink = (doctor) => {
            const url = `/doctor/${formatUrlString(doctor.display_name)}/${encryptId(doctor.id)}`
            // Generate a profile link - you can customize this based on your routing structure
            const baseUrl = window.location.origin;
            return `${baseUrl}${url}`;
        };

        const generateRandomPassword = (length = 12) => {
            const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            const lowercase = 'abcdefghijklmnopqrstuvwxyz';
            const numbers = '0123456789';
            const symbols = '!@#$%^&*';

            let password = '';

            // Ensure at least one character from each category
            password += uppercase.charAt(Math.floor(Math.random() * uppercase.length));
            password += lowercase.charAt(Math.floor(Math.random() * lowercase.length));
            password += numbers.charAt(Math.floor(Math.random() * numbers.length));
            password += symbols.charAt(Math.floor(Math.random() * symbols.length));

            // Fill the rest with random characters
            const allChars = uppercase + lowercase + numbers + symbols;
            for (let i = 4; i < length; i++) {
                password += allChars.charAt(Math.floor(Math.random() * allChars.length));
            }

            // Shuffle the password
            return password.split('').sort(() => Math.random() - 0.5).join('');
        };

        const ensureDoctorEmail = async (doctor) => {
            if (doctor?.email) return { email: doctor.email, createdDummy: false, tempPassword: null };
            const dummyEmail = `doctor${doctor.id}@meddylist.demo`;
            const tempPassword = generateRandomPassword();
            try {
                const tableSchema = '';
                const tableName = 'users';
                const payload = { email: dummyEmail, temp_password: tempPassword };
                const condition = { id: doctor.id };
                const res = await oneKlicks.update(tableSchema, tableName, payload, condition);
                if (res && res.success) {
                    setSelectedDoctorForShare((prev) => (prev ? { ...prev, email: dummyEmail, temp_password: tempPassword } : prev));
                }
            } catch (e) {
                // ignore, we'll still use the dummy locally
            }
            return { email: dummyEmail, createdDummy: true, tempPassword: tempPassword };
        };

        const handleSendToDoctor = async () => {
            if (!selectedDoctorForShare) return;
            setShareSending(true);
            try {
                const doctor = selectedDoctorForShare;
                const link = generateProfileLink(doctor);

                // Always send WhatsApp message when Send button is clicked
                if (doctor.phone) {
                    const whatsappMessage = `🏥 *Doctor Profile*

👨‍⚕️ *${doctor.display_name}*
${doctor.speciality_id ? `🏥 ${doctor.speciality_id}` : ''}
${doctor.country ? `🌍 ${doctor.country}` : ''}
${doctor.address ? `📍 ${doctor.address}` : ''}

🔗 *Profile Link:* ${link}

Book your appointment now! 📞`;

                    try {
                        const whatsappResponse = await sendWhatsApp(doctor.phone, whatsappMessage);
                        if (whatsappResponse && whatsappResponse.success) {
                            if (whatsappResponse.data && whatsappResponse.data.status === 'sent') {
                                message.success('WhatsApp message sent directly!');
                            } else {
                                message.success('WhatsApp message sent successfully!');
                            }
                        } else {
                            message.error('Failed to send WhatsApp message. Please try again.');
                        }
                    } catch (whatsappError) {
                        console.error('WhatsApp error:', whatsappError);
                        message.error('Failed to send WhatsApp message. Please try again.');
                    }
                } else {
                    message.error('Doctor phone number not available for WhatsApp sharing.');
                }

                // Log to DB
                try {
                    const tableSchema = '';
                    const tableName = 'doctor_share_requests';
                    const model = {
                        doctor_id: doctor.id,
                        email: doctor.email || '',
                        share_type: 'whatsapp',
                        payload: JSON.stringify({
                            type: 'whatsapp',
                            doctor_id: doctor.id,
                            link
                        }),
                        created_at: new Date().toISOString()
                    };
                    if (oneKlicks.create) {
                        await oneKlicks.create(tableSchema, tableName, model);
                    }
                } catch (e) {
                    // ignore if table/service not available
                }

                setShowShareModal(false);
            } catch (e) {
                message.error('Failed to send WhatsApp message.');
            } finally {
                setShareSending(false);
            }
        };

        // Function to add call_remarks column to database
        // NOTE: This function currently returns false because the addColumn endpoint
        // doesn't exist in the current OneKlicks API. The database administrator
        // needs to manually add the 'call_remarks' TEXT column to the 'users' table.
        const addCallRemarksColumn = async () => {
            try {
                // Since the addColumn endpoint doesn't exist in the current API,
                // we'll return false and let the calling function handle it gracefully
                console.log('Adding call_remarks column to database...');
                console.warn('addColumn endpoint not available in current API. Please contact administrator to add call_remarks column manually.');

                // Show user-friendly message
                message.warning('Call remarks feature requires database column to be added by administrator. Please contact support.');
                return false;
            } catch (error) {
                console.error('Error adding column:', error);
                message.error('Failed to add call remarks column: ' + error.message);
                return false;
            }
        };

        const handleSaveCallStatus = async () => {
            let call_status_date = '';
            if (!selectedDoctorForCallStatus) {
                setCallStatusModelshow(false);
                return;
            }
            try {
                let valueToSave = callStatusValue || '';
                if (valueToSave === 'Reschedule') {
                    if (!rescheduleDate) {
                        message.warning('Please pick a reschedule date and time');
                        return;
                    }
                    valueToSave = 'Reschedule';

                    const userId = await getuserdata("id");

                    // ✅ Fetch existing call_status_date if present
                    let existingData = selectedDoctorForCallStatus.call_status_date;
                    let parsedData = null;
                    if (existingData) {
                        try {
                            parsedData = JSON.parse(existingData);
                        } catch (e) {
                            parsedData = null;
                        }
                    }

                    if (parsedData && parsedData.date) {
                        // ✅ Append new reschedule entry inside "time" array
                        if (!Array.isArray(parsedData.date.time)) {
                            // convert old "time" string to array
                            parsedData.date.time = parsedData.date.time
                                ? [{ date: parsedData.date.time, user_id: parsedData.date.user_id }]
                                : [];
                        }

                        parsedData.date.time.push({
                            date: callStatusDate,  // new reschedule datetime
                            user_id: userId
                        });

                        call_status_date = parsedData;
                    } else {
                        // ✅ First time create fresh structure
                        call_status_date = {
                            date: {
                                date: rescheduleDate,
                                time: [
                                    {
                                        date: callStatusDate,
                                        user_id: userId
                                    }
                                ],
                                user_id: userId
                            }
                        };
                    }

                    call_status_date = JSON.stringify(call_status_date);
                }

                const tableSchema = '';
                const tableName = 'users';

                // Create payload with only non-empty values to avoid database issues
                const payload = {
                    call_status: valueToSave,
                    call_status_date: call_status_date
                };

                // Only add remarks if it's not empty
                if (callRemarks && callRemarks.trim() !== '') {
                    payload.call_remarks = callRemarks.trim();
                }

                console.log('Updating call status with payload:', payload);

                const condition = { id: selectedDoctorForCallStatus.id };

                // Try to update with remarks first
                let updateResponse;
                try {
                    updateResponse = await oneKlicks.update(tableSchema, tableName, payload, condition);
                } catch (error) {
                    console.log('Failed to update with remarks, trying to add column...', error);

                    // Try to add the call_remarks column if it doesn't exist
                    if (error.message.includes('Unknown column \'call_remarks\'')) {
                        const columnAdded = await addCallRemarksColumn();

                        // Since addColumn endpoint doesn't exist, we'll always fallback to updating without remarks
                        const payloadWithoutRemarks = {
                            call_status: valueToSave,
                            call_status_date: call_status_date
                        };
                        updateResponse = await oneKlicks.update(tableSchema, tableName, payloadWithoutRemarks, condition);
                        message.warning('Call status updated successfully! Remarks feature requires database column to be added by administrator.');
                    } else {
                        // For other errors, just fallback to updating without remarks
                        const payloadWithoutRemarks = {
                            call_status: valueToSave,
                            call_status_date: call_status_date
                        };
                        updateResponse = await oneKlicks.update(tableSchema, tableName, payloadWithoutRemarks, condition);
                        message.warning('Call status updated, but remarks could not be saved.');
                    }
                }

                if (updateResponse && updateResponse.success) {
                    message.success('Call status updated');
                    setCallStatusModelshow(false);
                    setSelectedDoctorForCallStatus(null);
                    await getHospitals();
                } else {
                    message.error('Failed to update call status');
                }
            } catch (error) {
                console.error('Call status update error:', error);
                if (error.message.includes('call_remarks')) {
                    message.error('Failed to update call status: Remarks field may not exist in database. Please contact administrator.');
                } else {
                    message.error('Failed to update call status: ' + error.message);
                }
            }
        };

        function safeParseRecursive(data) {
            let result = data;
            try {
                while (typeof result === "string") {
                    result = JSON.parse(result);
                }
            } catch (e) {
                // if it fails, just return the last good value
            }
            return result;
        }


        function cleanupCallStatus(rawJson) {
            let data;
            try {
                data = typeof rawJson === "string" ? JSON.parse(rawJson) : rawJson;
            } catch (e) {
                return null;
            }

            if (!data?.date) return data;

            // recursive fix for "time"
            function fixTimeArray(time) {
                if (!Array.isArray(time)) return time;

                return time
                    .map(t => {
                        let entry = { ...t };

                        // If entry.date looks like stringified JSON → try to parse
                        if (typeof entry.date === "string") {
                            let parsed = entry.date;
                            try {
                                while (typeof parsed === "string") {
                                    parsed = JSON.parse(parsed);
                                }
                                if (parsed?.date) {
                                    entry = parsed;
                                }
                            } catch (e) {
                                // invalid JSON, skip
                            }
                        }

                        return entry;
                    })
                    .filter(t => t.date && t.date !== "\"\"" && t.date !== ""); // remove junk
            }

            if (Array.isArray(data.date.time)) {
                data.date.time = fixTimeArray(data.date.time);
            }

            return data;
        }


        function normalizeCallStatus(raw) {
            let data;
            try {
                data = typeof raw === "string" ? JSON.parse(raw) : raw;
            } catch {
                return null;
            }
            if (!data?.date) return data;

            function cleanNode(node) {
                if (!node) return null;

                // if node is string → try to parse until stable
                if (typeof node === "string") {
                    try {
                        let parsed = node;
                        while (typeof parsed === "string") {
                            parsed = JSON.parse(parsed);
                        }
                        return cleanNode(parsed);
                    } catch {
                        return null;
                    }
                }

                // if node has .date
                if (node.date) {
                    node.date = cleanNode(node.date);
                }

                // if node has .time → ensure it's an array of cleaned nodes
                if (Array.isArray(node.time)) {
                    node.time = node.time
                        .map(cleanNode)
                        .filter(Boolean)                // remove nulls
                        .filter(t => t.date !== "\"\"" && t.date !== ""); // remove junk
                }

                return node;
            }

            data.date = cleanNode(data.date);
            return data;
        }




        return (
            <div className="dc-haslayout dc-dbsectionspace">

                <div className="container-fluid py-3">
                    <div className="card mb-5">
                        <div className="card-body">
                            <div className="align-items-center justify-content-between mb-3">
                                <div className="d-flex align-items-center gap-2  mb-2">
                                    <h5 className="mb-0 font-weight-bold mr-3">Hospitals Management</h5>
                                    <Badge bg="info">Hospitals</Badge>
                                </div>
                                <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                                    <div className="filters-wrapper">
                                        <InputGroup className="flex-grow-1 me-2 h-40">
                                            <Form.Control
                                                placeholder="Search..."
                                                value={searchText}
                                                onChange={(e) => setSearchText(e.target.value)}
                                            />
                                        </InputGroup>

                                        <Form.Select
                                            className="form-control select-control flex-grow-1 h-40"
                                            value={speciality}
                                            onChange={(e) => setSpeciality(e.target.value)}
                                        >
                                            <option value="" defaultValue>Select Speciality</option>
                                            {specialities.map((type) => (
                                                <option key={type.id} value={type.id}>{type.name}</option>
                                            ))}
                                        </Form.Select>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center" style={{ gap: '10px' }}>
                                        <Button className="btn-primary h-40" onClick={() => navigate("/superadmin/add-doctors?adddoctor=false&addhospital=true")}  >
                                            <PlusOutlined /> Add New Hospital
                                        </Button>
                                        {usertype === 'administrator' && (
                                            <>
                                                <Button className="btn-secondary h-40" onClick={openImportModal}>
                                                    <i className="ti-import"></i> Import Hospital
                                                </Button>

                                                <Button className="btn-secondary h-40" onClick={openImportModalimage}>
                                                    <i className="ti-image"></i> Import Images
                                                </Button>

                                                <Button className="btn-secondary h-40" onClick={openImportGoogleId}>
                                                    <i className="ti-google"></i> Import Google Info
                                                </Button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table hover size="sm" className="mb-0 align-middle">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Image</th>
                                            <th>Details</th>
                                            {/* <th>Email</th>
                                        <th>Phone</th> */}
                                            <th>Address</th>
                                            <th style={{ width: '220px' }}>Call Status</th>
                                            <th>Package</th>
                                            <th>Status</th>
                                            <th style={{ width: '310px' }}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((item) => (
                                            <tr key={item.id}>
                                                <td data-label="ID">{item.id}</td>
                                                <td>
                                                    <ImageShow
                                                        image={item.profile_photo !== "null" ? item.profile_photo : ""}
                                                        url={(item.profile_url !== "null" && item.profile_url) ? item.profile_url : (item.profile_photo_url !== "null" ? item.profile_photo_url : "")}
                                                        type="doctor"
                                                        width={50}
                                                        height={50}
                                                        style={{ objectFit: 'cover', borderRadius: '50%', width: '50px', height: '50px', boxShadow: '0px 0px 4px 0px black' }}
                                                    />
                                                </td>
                                                <td data-label="Details" style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                                    {item.display_name}
                                                    <br />
                                                    {item.email}
                                                    <br />
                                                    {item.phone}
                                                </td>
                                                {/* <td data-label="Email" style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }} title={item.email}>{item.email || '-'}</td>
                                            <td data-label="Phone" style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }} title={item.phone}>{item.phone || '-'}</td> */}
                                                <td data-label="Address" style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                                    {item.address ? (
                                                        <span>
                                                            {item.address.length > 30 ? (
                                                                <a
                                                                    href="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setModalData({ ...item, showAddressModal: true });
                                                                    }}
                                                                    style={{ color: '#1890ff', textDecoration: 'underline', cursor: 'pointer' }}
                                                                >
                                                                    {item.address.substring(0, 30)}...
                                                                </a>
                                                            ) : (
                                                                item.address
                                                            )}
                                                        </span>
                                                    ) : (
                                                        'No address'
                                                    )}
                                                </td>
                                                <td data-label="Call Status" >
                                                    <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center', flexWrap: 'nowrap', justifyContent: 'flex-end' }}>
                                                        <Button className="fit-content ss" onClick={() => openCallStatusModal(item)} style={{
                                                        }}>
                                                            {item.call_status == null ? "Not Set" : item.call_status}
                                                        </Button>
                                                        <Button className="fit-content" onClick={() => handleShareProfile(item)} style={{
                                                        }}>
                                                            Share Profile
                                                        </Button>
                                                    </div>
                                                </td>
                                                <td data-label="Package" style={{ textAlign: 'center' }}>
                                                    {item?.user_package?.length > 0 ? (
                                                        <span className={item.user_package[0].status == "active" ? "badge badge-success" : "badge badge-danger"}>
                                                            {item.user_package[0].package_details[0].name}
                                                        </span>
                                                    ) : (
                                                        <Button
                                                            className="fit-content"
                                                            onClick={() => openPackageModal(item)}
                                                            style={{
                                                                fontSize: '12px',
                                                                padding: '4px 12px'
                                                            }}
                                                        >
                                                            View Packages
                                                        </Button>
                                                    )}
                                                </td>
                                                <td data-label="Status" style={{ textAlign: 'center' }}>
                                                    <Button
                                                        onClick={() => handleStatusToggle(item)}
                                                        style={{
                                                            color: item.status == 1 ? '#52c41a' : '#ff4d4f',
                                                        }}
                                                        onMouseOver={(e) => {
                                                            e.target.style.transform = 'scale(1.02)';
                                                            e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.12)';
                                                        }}
                                                        onMouseOut={(e) => {
                                                            e.target.style.transform = 'scale(1)';
                                                            e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.06)';
                                                        }}
                                                    >
                                                        {item.status == 1 ? 'Active' : 'Inactive'}
                                                    </Button>
                                                </td>
                                                <td data-label="Action" >
                                                    <div style={{ display: 'flex', flexDirection: 'row', gap: '6px', alignItems: 'center', flexWrap: 'nowrap', justifyContent: 'flex-end' }}>
                                                        <Button className="dc-update-servicesss fit-content" onClick={() => {
                                                            navigate(`/superadmin/hospital-profile/${item.id}`);
                                                        }} style={{ borderColor: '#1890ff', color: '#1890ff' }}>
                                                            <EyeOutlined style={{ fontSize: '11px', marginRight: '4px' }} /> View
                                                        </Button>
                                                        <Button className="dc-update-servicesss fit-content" onClick={() => {
                                                            handleEditProfile(item);
                                                        }} style={{ borderColor: '#27ae60', color: '#27ae60' }}>
                                                            <EditOutlined style={{ fontSize: '11px', marginRight: '4px' }} /> Edit
                                                        </Button>
                                                        <Button className="dc-update-servicesss fit-content" onClick={(e) => {
                                                            e.preventDefault();
                                                            handleEdit(item, e);
                                                        }} style={{ borderColor: '#e67e22', color: '#e67e22' }}>
                                                            <LoginOutlined style={{ fontSize: '11px', marginRight: '4px' }} /> Login
                                                        </Button>
                                                        <Button className="dc-update-servicesss btn-danger" onClick={(e) => {
                                                            e.preventDefault();
                                                            handleDelete(item, e);
                                                        }} >
                                                            <DeleteOutlined style={{ fontSize: '11px', marginRight: '4px' }} /> Delete
                                                        </Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <Paginationnew currentPage={page} totalPages={totalPages} handlePageChange={handlePageChange} />
                        </div>
                    </div>
                </div>
                {showModal && (
                    <AddHospitals closeModal={closeModal} getHospitals={getHospitals} />
                )}

                {showEditModal && (
                    <EditHospitals closeModal={setShowEditModal} data={editData} getHospitals={getHospitals} />
                )}

                <Modal
                    title="Import Hospitals"
                    open={showImportModal}
                    onCancel={closeImportModal}
                    footer={[
                        <Button key="cancel" onClick={closeImportModal} disabled={isImporting}>
                            Cancel
                        </Button>,
                        <Button
                            key="import"
                            type="primary"
                            onClick={handleImport}
                            loading={isImporting}
                            disabled={isImporting}
                        >
                            Start Import
                        </Button>
                    ]}
                >
                    {isImporting ? (
                        <div>
                            <p>Importing doctors...</p>
                            <Progress percent={importProgress} status="active" />
                            <p style={{ marginTop: '10px' }}>{currentImportItem}</p>
                            <p style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                                Please do not close this window while import is in progress
                            </p>
                        </div>
                    ) : (
                        <p>Are you sure you want to import doctors? This process may take a few minutes.</p>
                    )}
                </Modal>

                <Modal
                    title="Import Images"
                    open={showImportModalimage}
                    onCancel={closeImportModalimage}
                    footer={[
                        <Button key="cancel" onClick={closeImportModalimage} disabled={isImporting}>
                            Cancel
                        </Button>,
                        <Button
                            key="import"
                            type="primary"
                            onClick={handleImportImages}
                            loading={isImporting}
                            disabled={isImporting}
                        >
                            Start Import
                        </Button>
                    ]}
                >
                    {isImporting ? (
                        <div>
                            <p>Importing images...</p>
                            <Progress percent={importProgress} status="active" />
                            <p style={{ marginTop: '10px' }}>{currentImportItem}</p>
                            <p style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                                Please do not close this window while import is in progress
                            </p>
                        </div>
                    ) : (
                        <div>
                            <p>Click "Start Import" to begin importing doctor profile images.</p>
                            <p style={{ fontSize: '12px', color: '#666' }}>
                                This will update profile URLs for doctors without profile images.
                            </p>
                        </div>
                    )}
                </Modal>

                <Modal
                    title="Import Specialities"
                    open={showImportGoogleId}
                    onCancel={closeImportGoogleId}
                    footer={[
                        <Button key="cancel" onClick={closeImportGoogleId} disabled={isImporting}>
                            Cancel
                        </Button>,
                        <Button
                            key="import"
                            type="primary"
                            onClick={handleImportGoogleId}
                            loading={isImporting}
                            disabled={isImporting}
                        >
                            Start Import
                        </Button>
                    ]}
                >
                    {isImporting ? (
                        <div>
                            <p>Importing Google Id...</p>
                            <Progress percent={importProgress} status="active" />
                            <p style={{ marginTop: '10px' }}>{currentImportItem}</p>
                            <p style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                                Please do not close this window while import is in progress
                            </p>
                        </div>
                    ) : (
                        <div>
                            <p>Click "Start Import" to begin importing Specialities.</p>
                            <p style={{ fontSize: '12px', color: '#666' }}>
                                This will update Specialities for doctors without Specialities.
                            </p>
                        </div>
                    )}
                </Modal>

                {/* Address Modal */}
                <Modal
                    title="Full Address"
                    open={modalData.showAddressModal}
                    onCancel={() => setModalData({ ...modalData, showAddressModal: false })}
                    footer={[
                        <Button key="close" onClick={() => setModalData({ ...modalData, showAddressModal: false })}>
                            Close
                        </Button>
                    ]}
                >
                    <div>
                        <h4>{modalData.display_name}</h4>
                        <p><strong>Address:</strong></p>
                        <p style={{
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                            backgroundColor: '#f5f5f5',
                            padding: '15px',
                            borderRadius: '5px',
                            border: '1px solid #d9d9d9'
                        }}>
                            {modalData.address || 'No address available'}
                        </p>
                    </div>
                </Modal>

                {/* Share Profile Modal */}
                <Modal
                    title="Share Doctor Profile"
                    open={showShareModal}
                    onCancel={closeShareModal}
                    footer={[
                        <Button key="close" onClick={closeShareModal} disabled={shareSending}>
                            Close
                        </Button>,
                        <Button
                            key="send"
                            type="primary"
                            onClick={handleSendToDoctor}
                            loading={shareSending}
                            disabled={shareSending || !selectedDoctorForShare?.phone}
                        >
                            Send WhatsApp
                        </Button>
                    ]}
                    width={500}
                >
                    {selectedDoctorForShare && (
                        <div>
                            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                <img
                                    src={process.env.REACT_APP_API_BASE_URL + selectedDoctorForShare.profile_url}
                                    alt="Profile"
                                    style={{
                                        width: '80px',
                                        height: '80px',
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                        border: '3px solid #1890ff'
                                    }}
                                />
                                <h4 style={{ marginTop: '10px', color: '#1890ff' }}>
                                    {selectedDoctorForShare.display_name}
                                </h4>
                                <p style={{ color: '#666', margin: '5px 0' }}>
                                    {selectedDoctorForShare.speciality_id || 'Specialist'}
                                </p>
                            </div>

                            {/* <div style={{ marginBottom: '16px' }}>
                                    <h5>Send As</h5>
                                    <Select
                                        options={shareTypeOptions}
                                        value={shareType}
                                        onChange={(v) => setShareType(v)}
                                        style={{ width: '100%' }}
                                    />
                                </div>           */}

                            <div style={{ marginBottom: '20px' }}>
                                <h5>📋 Profile Information</h5>
                                <div style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '5px' }}>
                                    <p><strong>Name:</strong> {selectedDoctorForShare.display_name}</p>
                                    <p><strong>Email:</strong> {selectedDoctorForShare.email}</p>
                                    <p><strong>Phone:</strong> {selectedDoctorForShare.phone || 'Not available'}</p>
                                    <p><strong>Country:</strong> {selectedDoctorForShare.country}</p>
                                    {selectedDoctorForShare.address && (
                                        <p><strong>Address:</strong> {selectedDoctorForShare.address}</p>
                                    )}
                                    {!selectedDoctorForShare.phone && (
                                        <p style={{ color: '#ff4d4f', fontWeight: 'bold' }}>
                                            ⚠️ WhatsApp sharing requires a phone number
                                        </p>
                                    )}
                                </div>
                            </div>
                            {/* WhatsApp Preview */}
                            <div>
                                <h5>WhatsApp Message Preview</h5>
                                <div style={{ background: '#fafafa', border: '1px solid #eee', borderRadius: 6, padding: 12, fontSize: 12 }}>
                                    <div style={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                        {`🏥 *Doctor Profile*

👨‍⚕️ *${selectedDoctorForShare.display_name}*
${selectedDoctorForShare.speciality_id ? `🏥 ${selectedDoctorForShare.speciality_id}` : ''}
${selectedDoctorForShare.country ? `🌍 ${selectedDoctorForShare.country}` : ''}
${selectedDoctorForShare.address ? `📍 ${selectedDoctorForShare.address}` : ''}

🔗 *Profile Link:* ${generateProfileLink(selectedDoctorForShare)}

Book your appointment now! 📞`}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal>

                {/* Package Modal */}
                <AddInvoiceModel showAdd={showPackageModal} setShowAdd={setShowPackageModal} data={""} mode="add" getdata={getHospitals} addbydocter={selectedHospital} />
            </div>

        );
};
export default Hospitals;
